import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../helpers'

const SidebarLogo = () => {
  return (
    <div className='flex items-center gap-3 px-4 mb-10' id='kt_app_sidebar_logo'>
      <Link to='/apps/hotel-management/hotels' className='flex items-center gap-3 no-underline'>
        <img
          alt='Touil Travel'
          src={toAbsoluteUrl('/media/logos/logo-touil.svg')}
          className='h-12 w-auto object-contain'
        />
      </Link>
    </div>
  )
}

export {SidebarLogo}
